import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import NotFound from "./NotFound";
import L1Dashboard from "../screen/dashboard";
import MyEvaluation from "../screen/myEvaluation/myEvaluation";
import MyEvaluationESII from "../screen/myEvaluation/myEvaluationESII";

const AppRoutes = ({ titlerolename, initialData }) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<L1Dashboard />} />
        <Route path="/l1dashboard" element={<L1Dashboard />} />
        <Route path="/my-evaluation" element={<MyEvaluation />} />
        <Route path="/my-evaluation-esii" element={<MyEvaluationESII />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
